module.exports = __webpack_public_path__ + "static/media/public-card-lounge.fff0de7e.jpg";